
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'
import Rule from '@/components/Rule.vue'
import Moment from 'moment'

@Options({
    components: {
        Rule,
    },
    computed: {
        ...mapState(['userInfo', 'shareData', 'activityData', 'aid'])
    },
    data() {
        return {
            showRule: false,
            isApp: false,
            notices: [], // [{ nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }, { nickname: 'U***1', prizeName: 'XX' }].splice(0, 100),
        }
    },
    mounted() {
        this.isApp = COVERAPP.Attribute.isApp()
        this.getList()

        this.$common.pageLoaded()
        let homeShareData = JSON.parse(JSON.stringify(this.shareData))
        homeShareData.link = window.location.href
        this.$common.onshare(homeShareData)
        this.$common.track('load', '进入首页')
    },
    methods: {
        ...mapMutations(["SET_DIALOGDATA"]),
        goSelect() {
            this.$router.push('/select1')
        },
        goMarket() {
            this.$router.push('/market')
        },
        goRecord() {
            this.$router.push('/record')
        },
        getList() {
            this.$request('/lottery/list', {
                aid: this.aid,
                page: 1,
                rows: 100,
                // type: 'redpacket',
            }).then((data: any) => {
                if(data) this.notices = data.filter((v: any) => v.prizeName != '翻牌红包' || v.amount).map((v:any) => {
                    return {
                        ...v,
                        name: this.$common.encrypt(v.nickname),
                        time: Moment(v.updateTime).format('YYYY-MM-DD'),
                        amount: v.amount ? (v.amount / 100).toFixed(2) : 0,
                    }
                });
            })
        },
        goPage(callback?: () => void) {
            if (!this.isApp && this.activityData.isAppShow) { //
                this.SET_DIALOGDATA({
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '取消',
                            className: 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className: 'download-btn'
                        }
                    ]
                })
                return false
            }
            if ((!this.userInfo || !this.userInfo.token)) {
                this.SET_DIALOGDATA({
                    text: '亲，请登录app并绑定手机号参与活动可获得红包哦！',
                    btns: [
                        {
                            text: '取消',
                            className: 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className: 'login-btn',
                            callback
                        }
                    ]
                })
                return false
            }
            if (!this.userInfo.mobile) {
                this.SET_DIALOGDATA({
                    text: '亲，请绑定手机号参与活动可获得红包哦！',
                    btns: [
                        {
                            text: '取消',
                            className: 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className: 'bindmobile-btn',
                            callback
                        }
                    ]
                })
                return false
            }
            callback && callback()
            return true
        }
    }
})
export default class Home extends Vue { }
